import useUserPermissions from './useUserPermissions';

function usePermissionStatus() {
    const {data: permissions = []} = useUserPermissions();

    const getPermissionStatus = (key) => {
        const permission = permissions.find((perm) => perm.key === key);
        return permission?.status ?? null;
    };

    return {getPermissionStatus};
}

export default usePermissionStatus;
